import { TableExpandKeys } from '../model';

export const isExpandDetail = (id: string, expandedKeys?: TableExpandKeys) => {
  if (!expandedKeys) {
    return false;
  }
  return !!expandedKeys.includes(id);
};
